import * as React from "react";
const SvgGridTypeSingleDouble20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M11 19V1H9v18h2ZM1 7h7v2H1V7Zm0 4h7v2H1v-2Zm11 0v2h7v-2h-7Zm0-4v2h7V7h-7Z",
      clipRule: "evenodd"
    })
  );
export default SvgGridTypeSingleDouble20Px;
